/**
 * #4336 — qual atendente o agendamento deve gravar.
 *
 * O bug: o modal mandava `ticketUserId: selectedUser?.id || null`, mas o
 * `selectedUser` só era carregado do agendamento quando o usuário NÃO era
 * admin. Como só admin pode editar agendamento (ScheduleController.update
 * exige profile admin), na prática o campo chegava sempre vazio na edição — e
 * salvar apagava o atendente que já estava vinculado.
 *
 * A regra aqui é simples e é a que evita a classe inteira do problema:
 * **grava quem está aparecendo na tela**. O campo mostra `selectedUser` para
 * admin e o próprio usuário para os demais; o que se salva passa a ser
 * exatamente isso.
 *
 * @param {{id:number}|null} selectedUser  escolhido no autocomplete (ou carregado do agendamento)
 * @param {{id:number}|null} currentUser   usuário logado
 * @param {boolean} isAdmin
 * @returns {number|null} id do atendente, ou null para "sem atendente"
 */
export function resolveScheduleAssigneeId(selectedUser, currentUser, isAdmin) {
  if (isAdmin) {
    // Admin escolhe livremente — inclusive "nenhum", limpando o campo.
    return selectedUser?.id ?? null;
  }

  // Não-admin não edita o campo (o autocomplete fica travado no próprio nome),
  // então vale o que veio do agendamento e, na falta, ele mesmo. Sem isto, um
  // agendamento criado por atendente nascia sem vínculo, apesar da tela
  // mostrar o nome dele.
  return selectedUser?.id ?? currentUser?.id ?? null;
}

export default resolveScheduleAssigneeId;
